import React from "react";
import PageHero from "../components/site/PageHero";
import MeetTyler from "../components/site/sections/MeetTyler";
import WhyChooseUs from "../components/site/sections/WhyChooseUs";
import Reviews from "../components/site/sections/Reviews";
import FinalCTA from "../components/site/FinalCTA";
import { IMG } from "../lib/site";
import Seo, { localBusinessSchema } from "../components/site/Seo";
import Breadcrumbs from "../components/site/Breadcrumbs";

const VALUES = [
  "Craftsmanship", "Communication", "Honesty", "Quality", "Relationships",
];

const About = () => (
  <div>
    <Seo
      title="About Tyler & PRYME EPOXY | Northern Arizona Floor Specialists"
      description="Meet Tyler, the owner of PRYME EPOXY. Learn why he started the company, his philosophy of never cutting corners, and his commitment to Northern Arizona homeowners."
      path="/about"
      jsonLd={localBusinessSchema()}
    />
    <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "About", path: "/about" }]} />
    <PageHero
      overline="About PRYME EPOXY"
      title="Built on Trust, Not Sales Pitches"
      subtitle="We're a local, owner-operated Northern Arizona company — not a franchise. Every project gets the same care, whether it's a garage in Prescott or a patio in Sedona."
      image={IMG.metallic}
    />

    <section className="py-16 bg-zinc-950 border-b border-zinc-900">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 text-center">
        <p className="text-zinc-300 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
          PRYME EPOXY believes that inviting someone onto your property is an act of trust that should never be taken
          lightly. Preparation matters. Communication matters. Craftsmanship matters. That's why we&rsquo;re
          <span className="text-[#C69453] font-semibold"> never cutting corners.</span>
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          {VALUES.map((v) => (
            <span key={v} className="border border-zinc-800 bg-[#141414] text-zinc-200 text-sm uppercase tracking-widest px-4 py-2">
              {v}
            </span>
          ))}
        </div>
      </div>
    </section>

    <section className="py-16 md:py-20 bg-[#0A0A0A]">
      <div className="max-w-3xl mx-auto px-5 lg:px-12 text-left">
        <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Tyler's Story</span>
        <h2 className="text-3xl md:text-4xl font-light text-white mt-2 mb-6">Why Tyler Started PRYME EPOXY</h2>
        <div className="space-y-4 text-zinc-300 text-lg leading-relaxed">
          <p>Tyler got tired of seeing the same thing over and over: homeowners paying good money for floors that peeled within a year because someone rushed the prep work.</p>
          <p>He started PRYME EPOXY on a simple idea — do it right, every single time, and treat every customer like a neighbor. No franchise playbook. No high-pressure sales. Just honest work and floors built to last.</p>
          <p>Today, Tyler still personally inspects and prepares every job, and his wife Juliana answers the phone and keeps every customer informed. When you call, you reach the family who owns PRYME EPOXY — not a call center. That's the difference, and it's why people across Northern Arizona trust us with their homes.</p>
          <p className="text-white font-semibold">We measure ourselves by our standards, not our slogans. That standard is simple: never cutting corners.</p>
        </div>
      </div>
    </section>

    <MeetTyler />
    <WhyChooseUs />
    <Reviews limit={3} />
    <FinalCTA />
  </div>
);

export default About;
